module.exports = __webpack_public_path__ + "img/shogi_2021_pack_1_0008.502dfbec.png";